import { render, staticRenderFns } from "./e-footer.vue?vue&type=template&id=38a58c56&scoped=true"
import script from "./e-footer.vue?vue&type=script&lang=js"
export * from "./e-footer.vue?vue&type=script&lang=js"
import style0 from "./e-footer.vue?vue&type=style&index=0&id=38a58c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a58c56",
  null
  
)

export default component.exports